import React, { useEffect } from "react";
import HomeBody from "./HomeBody";
import { useAuth } from "../../../hooks/useAuth";
import { useDashboard } from "../../../hooks/useDashboard";
import axiosInstance from "../../../helpers/axiosInstance";
import MainLayout from "../../shared/layouts/MainLayout";
import styled from "styled-components";

const PromoLink = styled.a`
  display: inline-block;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 25px;
  margin: 0 0 32px 0;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s ease;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(0);
  }
`;

function HomePage() {
  const { token } = useAuth();
  const { setMeta } = useDashboard();

  useEffect(() => {
    if (token) {
      axiosInstance.get("/dashboard")
        .then((response) => {
          setMeta(response.data.meta);
        })
    }
  }, [token]);

  return (
    <MainLayout>
      <PromoLink
        href="https://t.me/sqzyyy_bot?start=utmSource-myincome_utmCampaign-header"
        target="_blank"
        rel="noopener noreferrer"
      >
        🚀 Squeezy • Daily digest bot
      </PromoLink>
      <HomeBody />
    </MainLayout>
  );
}

export default HomePage;
